import React, { useState, useEffect } from 'react';
import LoginPopup from './LoginPopup';
import { useAuth } from './AuthContext';
import { useNavigate, Link } from 'react-router-dom';
import PublicHeader from '../../components/layout/PublicHeader';
const imageUrlLogoW = process.env.PUBLIC_URL + '/images/rmt-logo-white.png';
const ImpersonationBanner = ({ userName, onStopImpersonating }) => {
    if (localStorage.getItem('adminAsCustomer') !== 'yes') return null;
    return (
        <div className="tw-sticky tw-top-0 tw-z-[9999] tw-bg-amber-500 tw-text-black tw-text-center tw-py-2.5 tw-px-4 tw-font-bold tw-flex tw-items-center tw-justify-center tw-gap-4">
            <svg className="tw-w-5 tw-h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                <path strokeLinecap="round" strokeLinejoin="round" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
            </svg>
            <span>You are viewing as: {userName}</span>
            <button
                onClick={onStopImpersonating}
                className="tw-bg-black tw-text-white tw-border-0 tw-rounded tw-px-4 tw-py-1.5 tw-cursor-pointer tw-font-bold tw-text-sm"
            >
                Stop Impersonating
            </button>
        </div>
    );
};

const Dropdown = ({ label, icon, children }) => {
    const [open, setOpen] = useState(false);
    return (
        <div className="tw-relative" onMouseLeave={() => setOpen(false)}>
            <button
                onClick={() => setOpen(!open)}
                onMouseEnter={() => setOpen(true)}
                className="tw-flex tw-items-center tw-gap-1.5 tw-px-4 tw-py-2 tw-text-sm tw-font-medium tw-text-gray-200 hover:tw-text-white tw-rounded-lg hover:tw-bg-white/10 tw-transition-all tw-duration-200 tw-border-0 tw-bg-transparent tw-cursor-pointer tw-no-underline"
            >
                {icon}
                {label}
                <svg className="tw-w-3.5 tw-h-3.5 tw-ml-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
                </svg>
            </button>
            {open && (
                <div className="tw-absolute tw-top-full tw-left-0 tw-pt-1 tw-z-50">
                    <div className="tw-w-56 tw-bg-white tw-rounded-lg tw-shadow-lg tw-border tw-border-gray-200 tw-py-1">
                        {children}
                    </div>
                </div>
            )}
        </div>
    );
};

const DropdownItem = ({ to, children, onClick, disabled }) => (
    <Link
        to={to || '#'}
        onClick={onClick}
        className={`tw-flex tw-items-center tw-gap-2.5 tw-px-4 tw-py-2.5 tw-text-sm tw-no-underline tw-transition-colors ${
            disabled
                ? 'tw-text-gray-400 tw-cursor-default'
                : 'tw-text-gray-700 hover:tw-bg-gray-50 hover:tw-text-gray-900'
        }`}
    >
        {children}
    </Link>
);

const LoggedInMenu = ({ userName, userEmail, handleLogout, handleBackToAdmin }) => {
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const [userMenuOpen, setUserMenuOpen] = useState(false);

    const userInitial = userName ? userName.charAt(0).toUpperCase() : 'U';

    return (
        <>
            <ImpersonationBanner userName={userName} onStopImpersonating={handleBackToAdmin} />
            <header className="tw-sticky tw-top-0 tw-z-50 tw-bg-gray-900 tw-shadow-md">
                <div className="tw-max-w-7xl tw-mx-auto tw-px-4 sm:tw-px-6 lg:tw-px-8">
                    <div className="tw-flex tw-items-center tw-justify-between tw-h-16">
                        {/* Logo */}
                        <Link to="/account" className="tw-flex-shrink-0">
                            <img src={imageUrlLogoW} alt="RMT" className="tw-h-9" />
                        </Link>

                        {/* Desktop Navigation */}
                        <nav className="tw-hidden md:tw-flex tw-items-center tw-gap-1">
                            <Link
                                to="/account"
                                className="tw-flex tw-items-center tw-gap-1.5 tw-px-4 tw-py-2 tw-text-sm tw-font-medium tw-text-gray-200 hover:tw-text-white tw-rounded-lg hover:tw-bg-white/10 tw-transition-all tw-duration-200 tw-no-underline"
                            >
                                <svg className="tw-w-4 tw-h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-4 0a1 1 0 01-1-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 01-1 1" />
                                </svg>
                                Dashboard
                            </Link>

                            <Dropdown
                                label="Services"
                                icon={<svg className="tw-w-4 tw-h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 10h16M4 14h16M4 18h16" /></svg>}
                            >
                                <DropdownItem to="/account">
                                    <svg className="tw-w-4 tw-h-4 tw-text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M15 9h3.75M15 12h3.75M15 15h3.75M4.5 19.5h15a2.25 2.25 0 002.25-2.25V6.75A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25v10.5A2.25 2.25 0 004.5 19.5zm6-10.125a1.875 1.875 0 11-3.75 0 1.875 1.875 0 013.75 0zm-3.375 6.375h4.5" /></svg>
                                    License Plate Information
                                </DropdownItem>
                                <DropdownItem disabled>
                                    <svg className="tw-w-4 tw-h-4 tw-text-gray-300" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M2.25 12l8.954-8.955a1.126 1.126 0 011.591 0l8.955 8.955M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75" /></svg>
                                    Property Tax <span className="tw-text-xs tw-text-gray-400 tw-ml-auto">Coming Soon</span>
                                </DropdownItem>
                                <DropdownItem disabled>
                                    <svg className="tw-w-4 tw-h-4 tw-text-gray-300" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M15 9h3.75M15 12h3.75M15 15h3.75M4.5 19.5h15a2.25 2.25 0 002.25-2.25V6.75A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25v10.5A2.25 2.25 0 004.5 19.5z" /></svg>
                                    Driver's License <span className="tw-text-xs tw-text-gray-400 tw-ml-auto">Coming Soon</span>
                                </DropdownItem>
                            </Dropdown>

                            <Dropdown
                                label="Account"
                                icon={<svg className="tw-w-4 tw-h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.066 2.573c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.573 1.066c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.066-2.573c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" /><path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" /></svg>}
                            >
                                <DropdownItem to="/payment-methods">
                                    <svg className="tw-w-4 tw-h-4 tw-text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M2.25 8.25h19.5M2.25 9h19.5m-16.5 5.25h6m-6 2.25h3m-3.75 3h15a2.25 2.25 0 002.25-2.25V6.75A2.25 2.25 0 0019.5 4.5h-15A2.25 2.25 0 002.25 6.75v10.5A2.25 2.25 0 004.5 19.5z" /></svg>
                                    Payment Methods
                                </DropdownItem>
                                <DropdownItem to="/profile">
                                    <svg className="tw-w-4 tw-h-4 tw-text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M15 19.128a9.38 9.38 0 002.625.372 9.337 9.337 0 004.121-.952 4.125 4.125 0 00-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128H5.228A2.228 2.228 0 013 16.9c0-2.09 1.666-4.535 5.03-4.535.74 0 1.426.107 2.04.296M12 12.75a3.75 3.75 0 110-7.5 3.75 3.75 0 010 7.5z" /></svg>
                                    Saved Contacts
                                </DropdownItem>
                            </Dropdown>
                        </nav>

                        {/* Right side: User menu */}
                        <div className="tw-flex tw-items-center tw-gap-3">
                            {/* User dropdown (desktop) */}
                            <div className="tw-relative tw-hidden md:tw-block" onMouseLeave={() => setUserMenuOpen(false)}>
                                <button
                                    onClick={() => setUserMenuOpen(!userMenuOpen)}
                                    onMouseEnter={() => setUserMenuOpen(true)}
                                    className="tw-flex tw-items-center tw-gap-2 tw-px-3 tw-py-1.5 tw-rounded-lg hover:tw-bg-white/10 tw-transition-colors tw-border-0 tw-bg-transparent tw-cursor-pointer"
                                >
                                    <div className="tw-w-8 tw-h-8 tw-rounded-full tw-bg-blue-500 tw-flex tw-items-center tw-justify-center tw-text-white tw-text-sm tw-font-semibold">
                                        {userInitial}
                                    </div>
                                    <svg className="tw-w-3.5 tw-h-3.5 tw-text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
                                    </svg>
                                </button>
                                {userMenuOpen && (
                                    <div className="tw-absolute tw-top-full tw-right-0 tw-pt-1 tw-z-50">
                                    <div className="tw-w-64 tw-bg-white tw-rounded-lg tw-shadow-lg tw-border tw-border-gray-200 tw-py-1">
                                        <div className="tw-px-4 tw-py-3 tw-border-b tw-border-gray-100">
                                            <p className="tw-text-sm tw-font-semibold tw-text-gray-900 tw-m-0">{userName}</p>
                                            <p className="tw-text-xs tw-text-gray-500 tw-m-0 tw-mt-0.5">{userEmail}</p>
                                        </div>
                                        <DropdownItem to="/profile">
                                            <svg className="tw-w-4 tw-h-4 tw-text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0" /></svg>
                                            Your Profile
                                        </DropdownItem>
                                        <div className="tw-border-t tw-border-gray-100 tw-my-1"></div>
                                        <DropdownItem onClick={handleLogout}>
                                            <svg className="tw-w-4 tw-h-4 tw-text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M15.75 9V5.25A2.25 2.25 0 0013.5 3h-6a2.25 2.25 0 00-2.25 2.25v13.5A2.25 2.25 0 007.5 21h6a2.25 2.25 0 002.25-2.25V15m3 0l3-3m0 0l-3-3m3 3H9" /></svg>
                                            Logout
                                        </DropdownItem>
                                    </div>
                                    </div>
                                )}
                            </div>

                            {/* Mobile menu button */}
                            <button
                                onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                                className="md:tw-hidden tw-p-2 tw-rounded-lg hover:tw-bg-white/10 tw-transition-colors tw-border-0 tw-bg-transparent tw-cursor-pointer"
                                aria-label="Toggle menu"
                            >
                                {mobileMenuOpen ? (
                                    <svg className="tw-w-6 tw-h-6 tw-text-gray-200" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                                    </svg>
                                ) : (
                                    <svg className="tw-w-6 tw-h-6 tw-text-gray-200" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" />
                                    </svg>
                                )}
                            </button>
                        </div>
                    </div>
                </div>

                {/* Mobile menu */}
                {mobileMenuOpen && (
                    <div className="md:tw-hidden tw-border-t tw-border-gray-700 tw-bg-gray-800">
                        <div className="tw-px-4 tw-py-3">
                            {/* User info */}
                            <div className="tw-flex tw-items-center tw-gap-3 tw-pb-3 tw-mb-3 tw-border-b tw-border-gray-700">
                                <div className="tw-w-10 tw-h-10 tw-rounded-full tw-bg-blue-500 tw-flex tw-items-center tw-justify-center tw-text-white tw-font-semibold">
                                    {userInitial}
                                </div>
                                <div>
                                    <p className="tw-text-sm tw-font-semibold tw-text-white tw-m-0">{userName}</p>
                                    <p className="tw-text-xs tw-text-gray-400 tw-m-0">{userEmail}</p>
                                </div>
                            </div>

                            {/* Nav links */}
                            <Link to="/account" onClick={() => setMobileMenuOpen(false)} className="tw-block tw-px-3 tw-py-2.5 tw-text-sm tw-font-medium tw-text-gray-200 hover:tw-text-white hover:tw-bg-white/10 tw-rounded-lg tw-no-underline">Dashboard</Link>
                            <p className="tw-text-xs tw-font-semibold tw-text-gray-500 tw-uppercase tw-tracking-wider tw-mt-3 tw-mb-1 tw-px-3 tw-m-0">Services</p>
                            <Link to="/account" onClick={() => setMobileMenuOpen(false)} className="tw-block tw-px-3 tw-py-2.5 tw-text-sm tw-text-gray-300 hover:tw-text-white hover:tw-bg-white/10 tw-rounded-lg tw-no-underline">License Plate Information</Link>
                            <p className="tw-text-xs tw-font-semibold tw-text-gray-500 tw-uppercase tw-tracking-wider tw-mt-3 tw-mb-1 tw-px-3 tw-m-0">Account</p>
                            <Link to="/payment-methods" onClick={() => setMobileMenuOpen(false)} className="tw-block tw-px-3 tw-py-2.5 tw-text-sm tw-text-gray-300 hover:tw-text-white hover:tw-bg-white/10 tw-rounded-lg tw-no-underline">Payment Methods</Link>
                            <Link to="/profile" onClick={() => setMobileMenuOpen(false)} className="tw-block tw-px-3 tw-py-2.5 tw-text-sm tw-text-gray-300 hover:tw-text-white hover:tw-bg-white/10 tw-rounded-lg tw-no-underline">Saved Contacts</Link>

                            {/* Logout */}
                            <div className="tw-border-t tw-border-gray-700 tw-mt-3 tw-pt-3">
                                <button onClick={handleLogout} className="tw-w-full tw-text-left tw-px-3 tw-py-2.5 tw-text-sm tw-font-medium tw-text-red-400 hover:tw-text-red-300 hover:tw-bg-white/10 tw-rounded-lg tw-border-0 tw-bg-transparent tw-cursor-pointer">Logout</button>
                            </div>
                        </div>
                    </div>
                )}
            </header>
        </>
    );
};

const LoggedOutMenu = ({ handleLoginClick }) => {
    return <PublicHeader onSignInClick={handleLoginClick} />;
};

const Header = () => {
    const [isLoginOpen, setLoginOpen] = useState(false);
    const [isLoggedIn, setLoggedIn] = useState(false);
    const [userName, setUserName] = useState('');
    const [userEmail, setUserEmail] = useState('');
    const { logout } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        const token = localStorage.getItem('token');
        if (token) {
            setLoggedIn(true);
            const user = JSON.parse(localStorage.getItem('user'));
            if (user) {
                setUserName(user.name);
                setUserEmail(user.email);
            }
        }
    }, []);
    const handleLoginClick = () => {
        setLoginOpen(true);
    };

    const closeLoginPopup = () => {
        setLoginOpen(false);
    };

    const handleLogout = () => {
        logout();
        setLoggedIn(false);
        setUserName('');
        navigate('/');
    };

    const handleBackToAdmin = () => {
        logout();
        setLoggedIn(false);
        setUserName('');
        const adminUrl = (process.env.REACT_APP_API_URL || 'http://127.0.0.1:8000/api').replace('/api', '');
        window.location.href = adminUrl;
    };

    return (
        <>
            {isLoggedIn ? (
                <LoggedInMenu userName={userName} userEmail={userEmail} handleLogout={handleLogout} handleBackToAdmin={handleBackToAdmin} />
            ) : (
                <LoggedOutMenu handleLoginClick={handleLoginClick} />
            )}
            <LoginPopup isOpen={isLoginOpen} onRequestClose={closeLoginPopup} />
        </>
    );
};

export default Header;
